import moment from 'moment';
const DAY = 'YYYY-MM-DD';

/** The latest a printed bill date may fall after its service period. property-service keeps the same window (LB-6032). */
export const MAX_BILL_DATE_DAYS_AFTER_PERIOD = 180;

/**
 * A date as extraction wrote it, to the day. An ISO value must read whole, so "2026-08-09 garbage" is no date; it is
 * then cut to its date, so a time and offset on it can never move it to the day before.
 */
const toDay = value => {
  if (typeof value !== 'string' || !value.trim()) return null;
  const text = value.trim();
  const day = /^\d{4}-\d{2}-\d{2}/.test(text) ? moment(text, moment.ISO_8601, true).isValid() && moment(text.slice(0, 10), DAY, true) : moment(text, ['M/D/YYYY', 'MM/DD/YYYY'], true);
  return day && day.isValid() ? day : null;
};

/**
 * The date printed on the bill, as extraction read it, for the allocation bill to carry (LB-6032). It is what the
 * utility's bill ready date is learned from. Only `billDate`: the posting date is AppFolio's, and staff change it for
 * accounting reasons.
 *
 * Null unless it falls between the service start and 180 days after the service end, the window property-service
 * keeps. A date outside it is a misread, and the person saving has no field to correct it in, so it is left out
 * rather than sent.
 */
export const getExtractedBillDate = (extraction, startDateOnly, endDateOnly) => {
  const printed = toDay(extraction === null || extraction === void 0 ? void 0 : extraction.billDate);
  const start = toDay(startDateOnly);
  const end = toDay(endDateOnly);
  if (!printed || !start || !end) return null;
  const latest = end.clone().add(MAX_BILL_DATE_DAYS_AFTER_PERIOD, 'days');
  return printed.isBefore(start, 'day') || printed.isAfter(latest, 'day') ? null : printed.format(DAY);
};